(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luma-header-search')) {
    customElements.define('luma-header-search', class extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.details = this.querySelector('details');
        this.toggle = this.querySelector('summary');
        this.input = this.querySelector('input[type="search"]');
        this.header = this.closest('.header');
        this.toggle.setAttribute('role', 'button');
        this.toggle.setAttribute('aria-expanded', String(this.details.open));
        this.onOutsideClick = event => {
          if (this.details.open && !this.contains(event.target)) this.close(false);
        };
        this.details.addEventListener('toggle', () => {
          this.toggle.setAttribute('aria-expanded', String(this.details.open));
          if (this.details.open) {
            this.fitField();
            this.input.focus({ preventScroll: true });
          } else this.header?.classList.remove('luma-search-expanded');
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault(); this.close(true);
          }
        });
        document.addEventListener('click', this.onOutsideClick);
        this.resizeObserver = new ResizeObserver(() => {
          if (this.details.open) this.fitField();
        });
        if (this.header) this.resizeObserver.observe(this.header);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onOutsideClick);
        this.resizeObserver?.disconnect();
        this.header?.classList.remove('luma-search-expanded');
        this.initialised = false;
      }
      fitField() {
        if (!this.header) return;
        let right = this.getBoundingClientRect().left - 10;
        const logo = this.header.querySelector('.header__heading-link');
        const menu = this.header.querySelector('header-drawer');
        const logoEdge = logo?.getBoundingClientRect().right || 0;
        const compact = right - logoEdge < 180;
        this.header.classList.toggle('luma-search-expanded', compact);
        right = this.getBoundingClientRect().left - 10;
        const left = compact
          ? (menu?.getBoundingClientRect().right || this.header.getBoundingClientRect().left) + 12
          : logoEdge + 20;
        this.style.setProperty('--luma-inline-search-width', `${Math.max(80, Math.min(420, right - left))}px`);
      }
      close(returnFocus) {
        this.details.open = false;
        this.querySelector('predictive-search')?.close(true);
        if (returnFocus) this.toggle.focus({ preventScroll: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luma-chat-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.LumaNativeChat) return;
    window.LumaNativeChat = true;
    let api;
    let ready = false;
    let pendingOpen = window.location.hash === '#live-chat';
    const labels = document.querySelector('[data-luma-chat-icon-url]').dataset;
    const navigationStatuses = [];
    document.querySelectorAll('header a[href],header-drawer a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.hash !== '#live-chat') return;
      const badge = document.createElement('span');
      badge.className = 'luma-chat-nav-status';
      badge.setAttribute('data-luma-chat-status', '');
      link.appendChild(badge);
      navigationStatuses.push(badge);
    });
    function updateStatus(value) {
      const status = value === 'online' || value === 'offline' ? value : 'loading';
      window.LumaChatStatus = status;
      navigationStatuses.forEach(badge => {
        badge.dataset.status = status;
        badge.textContent = status === 'online' ? labels.onlineLabel : status === 'offline' ? labels.offlineLabel : labels.loadingLabel;
      });
      document.dispatchEvent(new CustomEvent('luma:chat-status', { detail: status }));
    }
    updateStatus('loading');
    function keepNativeCircle() {
      const root = document.getElementById('tidio-chat')?.shadowRoot;
      if (!root || root.getElementById('luma-native-circle')) return;
      const iconUrl = document.querySelector('[data-luma-chat-icon-url]')?.dataset.lumaChatIconUrl;
      const style = document.createElement('style');
      style.id = 'luma-native-circle';
      style.textContent = `
        #button.sidebar { --luma-chat-size: calc(var(--bubble-size, 56px) * 0.85); left: auto !important; right: calc(var(--luma-chat-size) * -0.2) !important; top: auto !important; bottom: calc(20px + var(--luma-chat-footer-offset, 0px)) !important; width: var(--luma-chat-size) !important; height: var(--luma-chat-size) !important; }
        #button.sidebar .sidebar-content { display: none !important; }
        #button.sidebar #button-body { inset: 0 !important; width: 100% !important; height: 100% !important; border-radius: 50% !important; }
        #button-body { background: var(--luma-accent) !important; border: 1px solid var(--luma-accent) !important; }
        #button-body .material-icons { color: var(--luma-page) !important; }
        #button-body .material-icons svg { fill: currentColor !important; }
        ${iconUrl ? `#button-body .material-icons.for-closed { width:25.5px !important; height:25.5px !important; left:50% !important; top:50% !important; transform:translate(-50%,-50%) !important; background:url("${iconUrl}") center/contain no-repeat; }
        #button-body .material-icons.for-closed svg { opacity:0 !important; }` : ''}
        #button-body:is(:hover, :focus-visible) { box-shadow: var(--luma-card-hover-glow) !important; }
        #button-body:focus-visible { outline: 2px solid var(--luma-text-light); outline-offset: 3px; }
      `;
      root.appendChild(style);
    }
    let footerFrame = 0;
    function positionAboveFooter() {
      footerFrame = 0;
      const footer = document.querySelector('footer.footer') || document.querySelector('footer');
      const offset = footer ? Math.max(0, window.innerHeight - footer.getBoundingClientRect().top) : 0;
      document.documentElement.style.setProperty('--luma-chat-footer-offset', `${offset}px`);
    }
    function scheduleFooterPosition() {
      if (!footerFrame) footerFrame = requestAnimationFrame(positionAboveFooter);
    }
    window.addEventListener('scroll', scheduleFooterPosition, { passive: true });
    window.addEventListener('resize', scheduleFooterPosition);
    const footerResizeObserver = new ResizeObserver(scheduleFooterPosition);
    footerResizeObserver.observe(document.body);
    positionAboveFooter();
    const nativeObserver = new MutationObserver(keepNativeCircle);
    nativeObserver.observe(document.body, { childList: true });
    keepNativeCircle();
    function openChat() {
      if (!ready) { pendingOpen = true; return; }
      pendingOpen = false;
      api.show();
      api.open();
    }
    function initialise() {
      if (ready || !window.tidioChatApi) return;
      api = window.tidioChatApi;
      if (typeof api.setColorPalette === 'function') {
        api.setColorPalette(getComputedStyle(document.documentElement).getPropertyValue('--luma-accent').trim());
      }
      ready = true;
      updateStatus(api.getStatus());
      api.on('setStatus', updateStatus);
      api.show();
      keepNativeCircle();
      if (pendingOpen) openChat();
    }
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a[href]');
      if (!link) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#live-chat') return;
      event.preventDefault(); openChat();
    });
    window.addEventListener('hashchange', () => { if (location.hash === '#live-chat') openChat(); });
    document.addEventListener('tidioChat-ready', initialise);
    if (window.tidioChatApi) {
      if (window.tidioChatApi.getStatus() !== null) initialise();
      else window.tidioChatApi.on('ready', initialise);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
